export default __webpack_public_path__ + "static/media/user.2c12a69b.svg";